import Icon from '@ant-design/icons';
import { Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import { SVGKnowledge, SVGDiagnose, SVGInsight } from '../../images';
import { useTranslation } from 'react-i18next';

export const menus = [
  {
    key: 'diagnose',
    label: 'menu_diagnose',
    icon: <Icon component={SVGDiagnose}></Icon>,
  },
  {
    key: 'knowledge',
    label: 'menu_knowledge_base',
    icon: <Icon component={SVGKnowledge}></Icon>,
  },
  {
    key: 'insight',
    label: 'menu_insights',
    icon: <Icon component={SVGInsight}></Icon>,
  },
];

const HeaderMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = location;

  const renderedMenus = menus.map((m) => ({ ...m, label: t(m?.label) }));

  return (
    <Menu
      mode="horizontal"
      theme="dark"
      selectedKeys={[pathname.split('/')[1]]}
      items={renderedMenus}
      onClick={({ key }) => {
        navigate(key);
      }}
    ></Menu>
  );
};

export default HeaderMenu;
